import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';
import FooterMultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions/FooterMultivariatePaymentOptions';

const ScienceAndResearchFooter = () => {
  return (
    <section
      className="bg-neutral-800 py-20"
      data-cy="science-and-research-footer"
    >
      <LandingPageJumbotron
        contentWidth="tight"
        title="science_and_research_footer_eyebrow"
        description="science_and_research_footer_title"
        macronIcon
        inverted
      />
      <FooterMultivariatePaymentOptions innerClassName="bg-neutral-900" />
    </section>
  );
};

export default ScienceAndResearchFooter;
